import {
  FormControlLabel,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import Menu from "@mui/material/Menu";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import React from "react";
import "./customDropdownList.css";
import IOSSwitch2 from "../../pages/paymentLink/IOSSwitch2";
import { colorBrandObject } from "../../../constants/brandings";
import { readableColor } from "polished";

const CustomDropdownList = ({
  open,
  handleClose,
  anchorEl,
  header,
  headerLogo,
  content,
}) => {
  const toolTipIconAndInfo = (message) => {
    return (
      <Tooltip title={message} arrow>
        <IconButton
          sx={{
            "&:hover": { backgroundColor: "transparent" },
          }}
          disableFocusRipple
          disableTouchRipple
        >
          <InfoOutlinedIcon
            sx={{
              height: "16px",
              width: "16px",
              border: "0px",
              color: "#000000D9",
            }}
          />
        </IconButton>
      </Tooltip>
    );
  };
  return (
    <Menu
      id="payment-link-menu"
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      MenuListProps={{
        "aria-labelledby": "basic-button",
      }}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      sx={{
        display: "flex",
        padding: "4px",
        borderRadius: "8px",
        marginTop: "6px",
      }}
    >
      <div className="setting-dropdown-header">
        {headerLogo}
        <Typography className="setting-dropdown-header-typography">
          {header}
        </Typography>
      </div>
      <div className="setting-dropdown-item-conatiner">
        {content?.map((item) => {
          return (
            <div style={{ display: 'flex', alignItems: "center", justifyContent: "space-between" }}>
              <div style={{ display: "flex", alignItems: "center" }}>

                <Typography className="setting-dropdown-item-typography">
                  {item?.header}
                </Typography>
                {item?.toolTipContent && toolTipIconAndInfo(item?.toolTipContent)}
              </div>
              {item?.type === "switch" && (
                <FormControlLabel
                  sx={{
                    margin: "0px !important",
                  }}
                  control={
                    <IOSSwitch2
                      sx={{
                        margin: "0px !important",
                        "& .MuiSwitch-switchBase.Mui-checked": {
                          color: "white"
                        },
                        "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                          backgroundColor: colorBrandObject?.secondaryButtonColor,
                        },
                      }}
                      activeColor={"#403E9F"}
                      onClick={() =>
                        item?.updateFunction(
                          item?.updateId,
                          !item?.initialState
                        )
                      }
                      checked={item?.initialState}
                    />
                  }
                />
              )}
            </div>
          );
        })}
      </div>
    </Menu>
  );
};

export default CustomDropdownList;